import { useMemo } from 'react';

import { selectAuth } from '~store/slices/auth';
import { CapacityTypeBase } from '~services/capacityTypes/types';

import { useAppSelector } from './useAppSelector';

interface UseCurrentCapacityTypeInfoReturn {
  unit1CapacityTypeId: CapacityTypeBase;
  unit2CapacityTypeId: CapacityTypeBase;
}

export const useCurrentCapacityTypeInfo =
  (): UseCurrentCapacityTypeInfoReturn => {
    const { currentCapacityTypes } = useAppSelector(selectAuth);

    const capacities = useMemo(
      () => ({
        unit1CapacityTypeId: currentCapacityTypes[0],
        unit2CapacityTypeId: currentCapacityTypes[1],
      }),
      [currentCapacityTypes],
    );

    return capacities;
  };
